module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'nav-open': _vm.$sidebar.showSidebar
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f37dea3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 746
// module chunks = 0